/*
  طبقات الفلتر ورحلة المي.
  - الضغط على أي طبقة يفعّلها ويحدّث البطاقة.
  - "شوف رحلة المي": قطرة تنزل على الخط المنقط، وكل ما توصل طبقة تتفعّل، لحد الطبقة الأخيرة.
  - القطرة تدخل وسخة (رمادي وبيها ذرات) وتصفى طبقة ورا طبقة، وتطلع من المخرج سماوي صافي بلمعة.
  - الزبون يگدر يوقف الرحلة أو يضغط أي طبقة بأي وقت، وبعدها يكمّل من مكانه.
  حالات الرحلة (data-journey-state): idle, playing, paused, done
*/
if (!customElements.get('hayat-layers')) {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  // لون القطرة: الرمادي الباهت (بدون فلتر) ← سماوي البراند (ويا فلتر حياة)
  const DIRTY_RGB = [179, 173, 163];
  const CLEAN_RGB = [115, 184, 227];

  customElements.define(
    'hayat-layers',
    class HayatLayers extends HTMLElement {
      connectedCallback() {
        this.layers = Array.from(this.querySelectorAll('[data-layer]'));
        if (this.layers.length === 0) return;

        this.stages = Array.from(this.querySelectorAll('.hayat-layers__stage[data-stage]'));
        this.stack = this.querySelector('[data-stack]');
        this.drop = this.querySelector('[data-drop]');
        this.journeyButtons = Array.from(this.querySelectorAll('[data-journey]'));
        this.card = {
          number: this.querySelector('[data-card-number]'),
          stage: this.querySelector('[data-card-stage]'),
          name: this.querySelector('[data-card-name]'),
          desc: this.querySelector('[data-card-desc]'),
          swatch: this.querySelector('[data-card-swatch]'),
          swatchFill: this.querySelector('[data-card-swatch-fill]'),
        };

        this.index = 0;
        this.timer = null;
        this.dropVisible = false;

        this.layers.forEach((layer, i) => {
          layer.addEventListener('click', () => this.onLayerClick(i));
        });
        this.journeyButtons.forEach((button) => {
          button.addEventListener('click', () => this.toggleJourney());
        });

        // إذا تغيّر عرض الرسم، نرجّع القطرة لمكانها الصحيح بدون حركة
        this.resizeObserver = new ResizeObserver(() => {
          if (this.dropVisible) this.moveDrop(this.layerCenter(this.index), 0);
        });
        this.resizeObserver.observe(this.stack);

        // إذا الزبون طلع من القسم والرحلة شغّالة، نوقفها
        this.visibilityObserver = new IntersectionObserver((entries) => {
          if (!entries[0].isIntersecting && this.state === 'playing') this.pause();
        });
        this.visibilityObserver.observe(this.stack);

        // بالمحرر: اختيار طبقة من القائمة يفعّلها
        this.onBlockSelect = (event) => {
          const i = this.layers.findIndex((layer) => layer.dataset.blockId === event.detail.blockId);
          if (i > -1) {
            this.stopTimer();
            this.activate(i);
          }
        };
        document.addEventListener('shopify:block:select', this.onBlockSelect);

        this.setState('idle');
        this.activate(0);
      }

      disconnectedCallback() {
        this.stopTimer();
        if (this.resizeObserver) this.resizeObserver.disconnect();
        if (this.visibilityObserver) this.visibilityObserver.disconnect();
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
      }

      /* ---------- التفعيل والبطاقة ---------- */

      activate(i) {
        this.index = i;
        const current = this.layers[i];

        this.layers.forEach((layer, n) => {
          const active = n === i;
          layer.classList.toggle('is-active', active);
          layer.setAttribute('aria-pressed', String(active));
        });
        this.stages.forEach((stage) => {
          stage.classList.toggle('is-active', stage.dataset.stageIndex === current.dataset.stageIndex);
        });

        if (this.card.number) this.card.number.textContent = current.dataset.number;
        if (this.card.stage) this.card.stage.textContent = current.dataset.stageLabel;
        if (this.card.name) this.card.name.textContent = current.dataset.name;
        if (this.card.desc) this.card.desc.textContent = current.dataset.desc;
        this.updateSwatch(current);
      }

      // الدائرة المكبّرة بالبطاقة تعرض نقشة ولون مادة الطبقة المفعّلة، ويا حركة تكبير خفيفة
      updateSwatch(current) {
        const { swatch, swatchFill } = this.card;
        if (!swatch || !swatchFill || !current.dataset.pattern) return;

        const fill = `url(#${current.dataset.pattern})`;
        if (swatchFill.getAttribute('fill') === fill) return;

        swatch.className = `hayat-layers__swatch hl-mat--${current.dataset.material}`;
        swatchFill.setAttribute('fill', fill);
        if (!reduceMotion.matches && swatch.animate) {
          swatch.animate(
            [
              { transform: 'scale(0.82) rotate(-12deg)', opacity: 0.4 },
              { transform: 'scale(1) rotate(0deg)', opacity: 1 },
            ],
            { duration: 320, easing: 'ease-out' }
          );
        }
      }

      // بداية الرحلة: كل الطبقات باهتة لحد ما القطرة توصل أول طبقة
      clearActive() {
        this.layers.forEach((layer) => {
          layer.classList.remove('is-active');
          layer.setAttribute('aria-pressed', 'false');
        });
        this.stages.forEach((stage) => stage.classList.remove('is-active'));
      }

      onLayerClick(i) {
        if (this.state === 'playing') this.pause();
        this.activate(i);
        if (this.dropVisible) {
          this.drop.classList.remove('is-clean');
          this.setPurity(this.purityAt(i));
          this.moveDrop(this.layerCenter(i), reduceMotion.matches ? 0 : 350);
          this.setState('paused');
        }
      }

      /* ---------- الرحلة ---------- */

      toggleJourney() {
        if (this.state === 'playing') {
          this.pause();
        } else if (this.state === 'paused') {
          this.resume();
        } else {
          this.start();
        }
      }

      start() {
        this.stopTimer();
        this.bringIntoView();
        this.clearActive();
        this.drop.classList.remove('is-clean');
        this.setPurity(0);
        this.showDrop(true);
        this.moveDrop(this.topY(), 0);
        this.setState('playing');
        this.timer = setTimeout(() => this.goTo(0), 350);
      }

      resume() {
        this.setState('playing');
        this.goTo(this.index + 1);
      }

      pause() {
        this.stopTimer();
        this.freezeDrop();
        this.setState('paused');
      }

      goTo(i) {
        if (i >= this.layers.length) {
          this.finish();
          return;
        }
        const travel = reduceMotion.matches ? 0 : 480;
        const dwell = reduceMotion.matches ? 1100 : 750;

        this.moveDrop(this.layerCenter(i), travel);
        this.timer = setTimeout(() => {
          this.activate(i);
          this.setPurity(this.purityAt(i));
          this.timer = setTimeout(() => this.goTo(i + 1), dwell);
        }, travel);
      }

      // القطرة تطلع من المخرج صافية بلمعة، وبعدها تختفي
      finish() {
        const travel = reduceMotion.matches ? 0 : 520;
        const shine = reduceMotion.matches ? 1100 : 950;
        this.moveDrop(this.bottomY(), travel);
        this.timer = setTimeout(() => {
          this.setPurity(1);
          this.drop.classList.add('is-clean');
          this.timer = setTimeout(() => {
            this.showDrop(false);
            this.setState('done');
          }, shine);
        }, travel);
      }

      stopTimer() {
        clearTimeout(this.timer);
        this.timer = null;
      }

      setState(state) {
        this.state = state;
        this.dataset.journeyState = state;
        this.journeyButtons.forEach((button) => {
          const label = button.dataset[`label${state.charAt(0).toUpperCase()}${state.slice(1)}`];
          if (label) button.setAttribute('aria-label', label);
        });
      }

      /* ---------- القطرة ---------- */

      layerCenter(i) {
        const cylinder = this.layers[i].querySelector('.hayat-layer__cyl') || this.layers[i];
        const box = cylinder.getBoundingClientRect();
        const stackBox = this.stack.getBoundingClientRect();
        return box.top - stackBox.top + box.height / 2;
      }

      topY() {
        return 10;
      }

      bottomY() {
        return this.stack.getBoundingClientRect().height - 10;
      }

      moveDrop(centerY, duration) {
        const y = Math.round(centerY - this.drop.offsetHeight / 2);
        this.drop.style.transitionDuration = `${duration}ms, 250ms`;
        this.drop.style.transform = `translateY(${y}px)`;
      }

      // يثبّت القطرة بمكانها الحالي لو انوقفت بنص الطريق
      freezeDrop() {
        const matrix = new DOMMatrixReadOnly(getComputedStyle(this.drop).transform);
        this.drop.style.transitionDuration = '0ms, 250ms';
        this.drop.style.transform = `translateY(${Math.round(matrix.m42)}px)`;
      }

      showDrop(visible) {
        this.dropVisible = visible;
        this.drop.classList.toggle('is-visible', visible);
      }

      // كم صافية القطرة بعد ما تعبر الطبقة i (من 0 لـ 1)
      purityAt(i) {
        return (i + 1) / this.layers.length;
      }

      /*
        صفاء القطرة من 0 (وسخة) لـ 1 (صافية):
        - اللون يتحول من الرمادي الباهت للسماوي على طول الرحلة
        - الذرات تختفي بأول ربع من الطبقات (طبقات الرواسب)
      */
      setPurity(level) {
        const t = Math.min(1, Math.max(0, level));
        const fill = DIRTY_RGB.map((dirty, k) => Math.round(dirty + (CLEAN_RGB[k] - dirty) * t));
        this.drop.style.setProperty('--drop-fill', `rgb(${fill.join(', ')})`);
        this.drop.style.setProperty('--drop-grit', String(Math.max(0, 1 - t / 0.25)));
        this.drop.style.setProperty('--drop-clean', String(t));
      }

      bringIntoView() {
        const box = this.stack.getBoundingClientRect();
        const headerHeight = parseFloat(getComputedStyle(document.documentElement).scrollPaddingTop) || 0;
        if (box.top < headerHeight || box.bottom > window.innerHeight) {
          this.stack.scrollIntoView({ behavior: reduceMotion.matches ? 'auto' : 'smooth', block: 'start' });
        }
      }
    }
  );
}
